import { dashboardPluginNavItems } from '../../plugins/registry';

/* what a plugin contributes to the sidebar menu; items with a `type`
   are drawn by a custom renderer instead of as a link */
export type NavItem = {
  to?: string;
  label?: string;
  labelKey?: string;
  iconClass?: string;
  group?: string;
  matchPath?: string;
  type?: string;
  /* an administration tool nobody else has use for */
  globalAdminOnly?: boolean;
};

export const dashboardNavItems: NavItem[] = dashboardPluginNavItems;
